export const environment = {
  production: true,
  apiUrl: "https://work-order-api-en3in3qzra-uc.a.run.app"
};
